export enum TableColumnsConfigKey {
  ACTIVITYLOGS = 'activitieslog',
  ASSET = 'asset',
  APPROVAL = 'approval',
  EMAILTEMPLATE = 'emailTemplate',
  FAULTEDINVOICES = 'FaultedInvoices',
  GROUP = 'group',
  GROUPUSERS = 'groupUsers',
  IMPORTHISTORY = 'importHistory',
  IMPORTHISTORYDETAIL = 'importHistoryDetail',
  IMPORTLOGS = 'importLogs',
  IMPORTLOGSDETAIL = 'importLogsDetail',
  INVOICECONTROL = 'invoicecontrol',
  INVOICEDISPATCHED = 'invoiceDispatched',
  INVOICELATEGRP = 'invoiceLateGroups',
  INVOICELATEINVOICES = 'invoiceLateInvoices',
  INVOICESEARCH = 'invoiceSearch',
  INVOICEREJECTED = 'invoiceRejected',
  INVOICEVOUCHERVALIDATED = 'invoiceVoucherValidated',
  INVOICEVOUCHERWORKFLOW = 'invoiceVoucherWorkflow',
  INVOICEPROMOTIONWORKFLOW = 'invoicePromotionWorkflow',
  MISSINGINVOICENUMBERS = 'missingInvoiceNumbers',
  RECIPIENTENTITY = 'recipientEntity',
  USER = 'user',
  WORKFLOW = 'workflow',
  WAITING = 'waiting',
  WORKFLOW_PROMOTION = 'workflow_promotion',
  INVOICEMODALPPRLOGS = 'invoiceModalPPRLogs',
}
